import _ from 'lodash';

export default function sanitizeContent({ content, ...rest }) {
  const blocks = _.map(content.blocks, removeRedundantTextAlignment);
  return {
    ...rest,
    content: {
      ...content,
      blocks,
    },
  };
}

/*
 Removes text alignment from atomic blocks, because when atomic block is in selection range it's possible to set it's data.textAlignment prop.
 Removes left text alignment from text blocks, because it's a default value.
 */
function removeRedundantTextAlignment(block) {
  return block.type === 'atomic' ? omitTextAlignment(block) : omitLeftTextAlignment(block);
}

function omitLeftTextAlignment(block) {
  return block.data.textAlignment === 'left' ? omitTextAlignment(block) : block;
}

function omitTextAlignment(block) {
  return _.omit(block, 'data.textAlignment');
}



// WEBPACK FOOTER //
// ./app/services/sanitize-content.js